module.exports = __webpack_public_path__ + "img/shakhtyor.ef017e31.png";